import styled from 'styled-components';

export const ResultsOrganicStyle = styled.div`
    width: 40%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;